export const MapToChart = (data) => {
    let returnValue = [];
    data.map((item, index) => {
        returnValue.push(
            {
                id: item.id,
                cardCategory: item.requestType,
                createDate: item.createdDate.split('T')[0]
            }
        )
    })
    return returnValue;
    // return returnValue.reduce((r, a) => {
    //     r[a.cardCategory] = [...r[a.cardCategory] || [], a];
    //     // console.log('TEST UNIT :'+JSON.stringify(r))
    //     return r;
    // }, {});
}

export const MapToTable = (data) => {
    let returnValue = [];
    data.map((item, index) => {
        returnValue.push(
            {
                nik: item.requestData.identityNumber,
                fullName: item.requestData.fullName,
                phoneNumber: item.requestData.phoneNumber,
                category: item.requestCategory.name,
                createdDate: item.createdDate.split('T')[0],
                requestType: item.requestType,
                requestStatus: item.requestStatus.name,
            }
        )
    })
    return returnValue;
}

export const MapToCounter = (data) => {
    return data.reduce((p, c) => {
        let category = c.requestStatus;
        if (!p.hasOwnProperty(category)) {
            p[category] = 0;
        }
        p[category]++;
        return p
    }, {});
}

export const translateRequestType = (word) => {
    if (word === 'NEW') {
        return 'Pendaftaran Kartu Baru'
    } else if (word === 'BROKEN') {
        return 'Penggantian Kartu Rusak'
    } else {
        return 'Penggantian Kartu Hilang'
    }
}


export const translateRequestStatus = (word) => {
    if (word.includes('CREATED')) {
        return 'DIBUAT';
    } else if (word.includes('PROGRESS')) {
        return 'PROSES PEMBUATAN';
    } else if (word.includes('PENDING')) {
        return 'MENUNGGU';
    } else if (word.includes('REJECTED')) {
        return 'DITOLAK';
    } else if (word.includes('APPROVED')) {
        return 'DISETUJUI';
    } else if (word.includes('READY')) {
        return 'SIAP DI AMBIL';
    } else if (word.includes('TAKE_BY_USER')) {
        return 'DIAMBIL';
    }


}
